import { render, staticRenderFns } from "./mzDrugBank.vue?vue&type=template&id=6cad2500&scoped=true"
import script from "./mzDrugBank.vue?vue&type=script&lang=js"
export * from "./mzDrugBank.vue?vue&type=script&lang=js"
import style0 from "./mzDrugBank.vue?vue&type=style&index=0&id=6cad2500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad2500",
  null
  
)

export default component.exports